import chats, { ChatUserRolesEnum } from 'constants/chats';
import {
  applyDialogInfoSuccess,
  applyOpenExistingDialog,
  applyOpenedDialogFromByPeer,
  applySelectChat,
  buildPendingSelectedDialogInfo,
} from 'redux/model/chats/pendingChat';
import { applyReceiveWebsocketMessage } from 'redux/model/chats/receiveWebsocketMessage';
import { updateUnreadMessagesCounter } from 'redux/model/chats/updateUnreadMessagesCounter';
import { SearchDialogUrlParams, toSearchInDialogQuery } from 'redux/utils/searchInDialog.utils';
import { getInitialsFromFullname } from 'services/chat.sevice';
import { ChatContentEnum, ChatDescription, ChatMessage, Folder, SelectedDialogInfo } from 'types/chatsType';
import { FileDescriptor } from 'types/fileTypes';
import {
  POLL_ANSWER_USERS_PAGE_SIZE,
  POLL_PREVIEW_VOTERS_COUNT,
  initialPollAnswerUsersState,
} from 'types/pollTypes';
import { ActionType, PayloadErrorType } from 'types/reduxTypes';
import { ChatType } from 'types/stateTypes';
import {
  applySelectedDialogInfoToListItem,
  createChatListItemFromSelectedDialogInfo,
  getChatPreviewFromWsMessage,
  getNotificationInfo,
  getUser,
  normalizeDialogsPreviews,
  sortChatsByPinAndLastMessage,
  stripUsersFromDialogs,
} from 'utils/chats.utils.typed';
import { updatePollInChatInfo } from 'utils/poll.utils';
import {
  ChangeUploadFilesPayload,
  CreateGroupSuccessPayload,
  DeleteDialogSuccessPayload,
  EditChatFolderPayload,
  FetchChatsSuccessPayload,
  GetChatInfoSuccessPayload,
  GetPollAnswerUsersSuccessPayload,
  GetUpdatedChatInfoSuccessPayload,
  GetUsersListSuccessPayload,
  OpenPendingChatPayload,
  PollVoteSuccessPayload,
  ReadMessagesSuccessPayload,
  ReceiveWebsocketMessagePayload,
  SearchInDialogSuccessPayload,
  SetEditableMessagePayload,
  StopPollSuccessPayload,
  UpdateGroupSuccessPayload,
  UpdateMessagePayload,
  UploadFileSuccessPayload,
  UsersStatusSuccessItem,
} from '../actions/chatsActions';
import {
  CREATE_CHAT_FOLDER,
  CREATE_CHAT_FOLDER_FAILED,
  CREATE_CHAT_FOLDER_SUCCESS,
  DELETE_CHAT_FOLDER,
  DELETE_CHAT_FOLDER_FAILED,
  DELETE_CHAT_FOLDER_SUCCESS,
  EDIT_CHAT_FOLDER,
  EDIT_CHAT_FOLDER_FAILED,
  EDIT_CHAT_FOLDER_SUCCESS,
  GET_CHAT_FOLDERS,
  GET_CHAT_FOLDERS_FAILED,
  GET_CHAT_FOLDERS_SUCCESS,
  GET_FOLDER_DIALOGS_SUCCESS,
  REORDER_FOLDERS,
  REORDER_FOLDERS_FAILED,
  REORDER_FOLDERS_SUCCESS,
  SELECT_CHAT_FOLDER,
  SET_FOLDERS,
  SET_FOLDER_DATA,
} from '../constants/chatFolders';
import {
  BLOCK_DIALOG,
  BLOCK_DIALOG_FAILED,
  BLOCK_DIALOG_SUCCESS,
  CHANGE_LOAD_MESSAGE_STATUS,
  CHANGE_UPLOAD_FILES,
  CLEAR_CHATS,
  CLEAR_DIALOG_INFO,
  CLEAR_ERRORS,
  CLEAR_NOTIFICATION_INFO,
  CLEAR_POLLS,
  CLEAR_POLL_ACTION_ERROR,
  CLEAR_POLL_INFO,
  CLEAR_SEARCH_IN_DIALOG,
  CREATE_GROUP_FAILED,
  CREATE_GROUP_SUCCESS,
  CREATE_POLL,
  CREATE_POLL_FAILED,
  CREATE_POLL_SUCCESS,
  DECREASE_MESSAGE_COUNT,
  DELETE_CHAT_SUCCESS,
  DELETE_GROUP_CHAT_SUCCESS,
  DELETE_MESSAGES,
  DELETE_MESSAGES_FAILED,
  DELETE_MESSAGES_SUCCESS,
  DISABLE_NOTIFICATIONS_FAILED,
  DISABLE_NOTIFICATIONS_SUCCESS,
  ENABLE_NOTIFICATIONS_FAILED,
  ENABLE_NOTIFICATIONS_SUCCESS,
  FETCH_CHATS,
  FETCH_CHATS_FAILED,
  FETCH_CHATS_SUCCESS,
  GET_CHAT_INFO,
  GET_CHAT_INFO_FAILED,
  GET_CHAT_INFO_SUCCESS,
  GET_DIALOG_INFO_BY_PEER,
  GET_DIALOG_INFO_BY_PEER_FAILED,
  GET_DIALOG_INFO_BY_PEER_SUCCESS,
  GET_DIALOG_INFO_FAILED,
  GET_DIALOG_INFO_SUCCESS,
  GET_POLL,
  GET_POLL_ANSWER_USERS,
  GET_POLL_ANSWER_USERS_FAILED,
  GET_POLL_ANSWER_USERS_SUCCESS,
  GET_POLL_FAILED,
  GET_POLL_SUCCESS,
  GET_UPDATED_CHAT_INFO_FAILED,
  GET_UPDATED_CHAT_INFO_SUCCESS,
  GET_USERS_LIST,
  GET_USERS_LIST_FAILED,
  GET_USERS_LIST_SUCCESS,
  GET_USERS_STATUS_FAILED,
  GET_USERS_STATUS_SUCCESS,
  INCREASE_MESSAGE_COUNT,
  INVITE_USER_FAILED,
  LEAVE_GROUP_FAILED,
  LEAVE_GROUP_SUCCESS,
  MAKE_USER_ADMIN_SUCCESS,
  OPEN_EXISTING_DIALOG,
  OPEN_PENDING_CHAT,
  PIN_CHAT_FAILED,
  PIN_CHAT_SUCCESS,
  READ_MESSAGES_FAILED,
  READ_MESSAGES_SUCCESS,
  RECEIVE_WEBSOCKET_MESSAGE,
  REMOVE_ADMIN_SUCCESS,
  REMOVE_UPLOAD_GROUP_AVATAR,
  RESET_SEARCH_RESULT,
  SEARCH_DIALOGS,
  SEARCH_DIALOGS_FAILED,
  SEARCH_DIALOGS_SUCCESS,
  SEARCH_GLOBAL_CHAT,
  SEARCH_GLOBAL_CHAT_FAILED,
  SEARCH_GLOBAL_CHAT_SUCCESS,
  SEARCH_IN_DIALOG,
  SEARCH_IN_DIALOG_FAILED,
  SEARCH_IN_DIALOG_SUCCESS,
  SELECT_CHAT,
  SET_ANSWER_MESSAGE,
  SET_CHAT_CONTENT,
  SET_EDITABLE_MESSAGE,
  SET_GROUP_USER_LIST,
  SET_SELECTED_MESSAGES,
  SET_SELECTION_MODE,
  STOP_POLL,
  STOP_POLL_FAILED,
  STOP_POLL_SUCCESS,
  SUBMIT_POLL_ANSWER,
  SUBMIT_POLL_ANSWER_FAILED,
  SUBMIT_POLL_ANSWER_SUCCESS,
  TOGGLE_CHAT,
  UNBLOCK_DIALOG,
  UNBLOCK_DIALOG_FAILED,
  UNBLOCK_DIALOG_SUCCESS,
  UNPIN_CHAT_FAILED,
  UNPIN_CHAT_SUCCESS,
  UPDATE_GROUP,
  UPDATE_GROUP_FAILED,
  UPDATE_GROUP_SUCCESS,
  UPDATE_MESSAGE_FAILED,
  UPDATE_MESSAGE_SUCCESS,
  UPLOAD_ATTACHED_FILE_SUCCESS,
  UPLOAD_FILE_FAILED,
  UPLOAD_GROUP_AVATAR_SUCCESS,
} from '../constants/chats';
import {
  deleteDialog,
  getDesktopState,
  getMobileState,
  insertAtSecondLast,
  removeDuplicates,
  updateChatMessages,
  updateUploadedData,
} from '../utils/chatUtils';

type ActionWithMessage = ActionType<unknown> & { message?: string };

/** 
  TODO временно — сага отправляет ошибку и в payload, и в message. 
  При типизации саг - привести к общему виду и убрать 
*/
const errorTextFrom = (action: ActionWithMessage): string => {
  if (typeof action.payload === 'string') return action.payload;
  if (typeof action.message === 'string') return action.message;
  return '';
};

const withError = (state: ChatType, action: ActionWithMessage, other: Partial<ChatType> = {}): ChatType => ({
  ...state,
  errorText: errorTextFrom(action),
  ...other,
});

const initialState: ChatType = {
  chatContent: ChatContentEnum.chat,
  chatInfo: [],
  chats: [],
  createGroupUserList: [],
  createdPolls: [],
  editFolderData: {
    folderDialogs: [],
    id: null,
    name: '',
  },
  editableMessage: null,
  error: false,
  errorText: '',
  folder: null,
  folders: [],
  foundChats: [],
  foundDialogs: [],
  groupAvatar: null,
  groupUserList: [],
  hasMore: true,
  hasMoreSearchInDialog: false,
  isChatOpen: false,
  isCreatingPoll: false,
  isEditMode: false,
  isPollDetailsLoading: false,
  isPollLoading: false,
  lastMessageId: 0,
  lastUploadFiles: [],
  loadMessageStatus: false,
  loading: false,
  loadingActionMessage: false,
  loadingByPeer: false,
  loadingChatInfo: false,
  loadingChats: false,
  loadingFolders: false,
  loadingSearchDialogs: false,
  loadingSearchInDialog: false,
  loadingUsersList: false,
  newNotificationInfo: null,
  pollActionError: false,
  pollAnswerUsersState: initialPollAnswerUsersState(),
  pollDetailsError: null,
  pollInfo: null,
  searchCount: 0,
  searchInDialogQuery: null,
  searchMessageResult: [],
  selectedChatId: null,
  selectedDialogInfo: null,
  selectedMessages: [],
  selectionMode: false,
  uploadFilesInfo: [],
  usersList: [],
};

export default (state = initialState, action: ActionType<unknown>): ChatType => {
  switch (action.type) {
    case BLOCK_DIALOG: {
      return { ...state, loadingChatInfo: true };
    }
    case BLOCK_DIALOG_FAILED: {
      return withError(state, action, { loadingChatInfo: false });
    }
    case BLOCK_DIALOG_SUCCESS: {
      const payload = action.payload as number;
      const newChats = [...state.chats].filter((chat) => chat.id !== payload);
      return { ...state, chats: newChats, loadingChatInfo: false };
    }
    case CHANGE_LOAD_MESSAGE_STATUS: {
      const payload = action.payload as boolean;
      return { ...state, loadMessageStatus: payload, loadingChatInfo: false };
    }
    case CHANGE_UPLOAD_FILES: {
      const payload = action.payload as ChangeUploadFilesPayload;
      const { fileId, isClear } = payload;
      const { lastUploadFiles } = state;
      const updatedFiles = updateUploadedData({ fileId, isClear, uploadedFilesData: lastUploadFiles });
      return { ...state, lastUploadFiles: updatedFiles };
    }
    case CLEAR_CHATS: {
      return { ...state, chats: [] };
    }
    case CLEAR_DIALOG_INFO: {
      return { ...state, chatInfo: [], selectedChatId: null, selectedDialogInfo: null };
    }
    case CLEAR_ERRORS: {
      return { ...state, error: false, errorText: '' };
    }
    case CLEAR_NOTIFICATION_INFO: {
      return { ...state, newNotificationInfo: null };
    }
    case CLEAR_POLL_ACTION_ERROR: {
      if (!state.pollActionError) {
        return state;
      }
      return { ...state, pollActionError: false };
    }
    case CLEAR_POLL_INFO: {
      return {
        ...state,
        isPollDetailsLoading: false,
        pollAnswerUsersState: initialPollAnswerUsersState(),
        pollDetailsError: null,
        pollInfo: null,
      };
    }
    case CLEAR_POLLS: {
      return { ...state, createdPolls: [] };
    }
    case CLEAR_SEARCH_IN_DIALOG: {
      return {
        ...state,
        hasMoreSearchInDialog: false,
        loadingSearchInDialog: false,
        searchInDialogQuery: null,
        searchMessageResult: [],
      };
    }
    case CREATE_CHAT_FOLDER: {
      return { ...state, loadingFolders: true };
    }
    case CREATE_CHAT_FOLDER_FAILED: {
      return { ...state, loadingFolders: false };
    }
    case CREATE_CHAT_FOLDER_SUCCESS: {
      const payload = action.payload as Folder;
      const newState = insertAtSecondLast([...state.folders], payload);
      return { ...state, folders: newState, loadingFolders: false };
    }
    case CREATE_GROUP_FAILED: {
      return { ...state, loadingChatInfo: false };
    }
    case CREATE_GROUP_SUCCESS: {
      const payload = action.payload as CreateGroupSuccessPayload;
      return { ...state, isChatOpen: true, selectedChatId: payload.id, selectedDialogInfo: null };
    }
    case CREATE_POLL: {
      return { ...state, isCreatingPoll: true };
    }
    case CREATE_POLL_FAILED: {
      return { ...state, isCreatingPoll: false };
    }
    case CREATE_POLL_SUCCESS: {
      const payload = action.payload as ChatType['createdPolls'][number];
      return {
        ...state,
        createdPolls: [...state.createdPolls, payload],
        isCreatingPoll: false,
      };
    }
    case DECREASE_MESSAGE_COUNT: {
      return { ...state, loadingChatInfo: true };
    }
    case DELETE_CHAT_FOLDER: {
      return { ...state, loadingFolders: true };
    }
    case DELETE_CHAT_FOLDER_FAILED: {
      return { ...state, loadingFolders: false };
    }
    case DELETE_CHAT_FOLDER_SUCCESS: {
      const payload = action.payload as Folder['id'];
      return { ...state, folders: [...state.folders.filter((folder) => folder.id !== payload)], loadingFolders: false };
    }
    case DELETE_CHAT_SUCCESS: {
      const payload = action.payload as DeleteDialogSuccessPayload;
      const { chats } = state;
      const updatedChats = deleteDialog({ chats, dialog: payload.id });

      if (payload.isMobile) {
        const mobileNewState = getMobileState({ state, updatedChats });
        return mobileNewState;
      }
      const desktopNewState = getDesktopState({ state, updatedChats });
      return desktopNewState;
    }
    case DELETE_GROUP_CHAT_SUCCESS: {
      const payload = action.payload as DeleteDialogSuccessPayload;
      const { chats } = state;
      const updatedChats = deleteDialog({ chats, dialog: payload.id });
      const mobileNewState = getMobileState({ state, updatedChats });
      const desktopNewState = getDesktopState({ state, updatedChats });
      return payload.isMobile ? mobileNewState : desktopNewState;
    }
    case DELETE_MESSAGES: {
      return { ...state, loadingActionMessage: true };
    }
    case DELETE_MESSAGES_FAILED: {
      return withError(state, action, { error: true, loadingActionMessage: false });
    }
    case DELETE_MESSAGES_SUCCESS: {
      return { ...state, loadingActionMessage: false };
    }
    case DISABLE_NOTIFICATIONS_FAILED: {
      return withError(state, action);
    }
    case DISABLE_NOTIFICATIONS_SUCCESS: {
      const payload = action.payload as number;
      const updatedChats = state.chats.map((chat) =>
        chat.id === payload ? { ...chat, notificationsDisable: true } : chat
      );
      return { ...state, chats: updatedChats };
    }
    case EDIT_CHAT_FOLDER: {
      return { ...state, loadingFolders: true };
    }
    case EDIT_CHAT_FOLDER_FAILED: {
      return { ...state, loadingFolders: false };
    }
    case EDIT_CHAT_FOLDER_SUCCESS: {
      const payload = action.payload as EditChatFolderPayload;
      const newState = state.folders.map((folder) =>
        folder.id === payload.id ? { ...folder, name: payload.name } : folder
      );
      return {
        ...state,
        chats: payload.dialogs ?? state.chats,
        folders: newState,
        loadingFolders: false,
      };
    }
    case ENABLE_NOTIFICATIONS_FAILED: {
      return withError(state, action);
    }
    case ENABLE_NOTIFICATIONS_SUCCESS: {
      const payload = action.payload as number;
      const updatedChats = state.chats.map((chat) =>
        chat.id === payload ? { ...chat, notificationsDisable: false } : chat
      );
      return { ...state, chats: updatedChats };
    }
    case FETCH_CHATS: {
      return { ...state, loadingChats: true };
    }
    case FETCH_CHATS_FAILED: {
      return withError(state, action, { loadingChats: false });
    }
    case FETCH_CHATS_SUCCESS: {
      const { count, dialogs, isAppend } = action.payload as FetchChatsSuccessPayload;
      return {
        ...state,
        chats: removeDuplicates({
          chats: state.chats,
          dialogs: stripUsersFromDialogs(normalizeDialogsPreviews(dialogs)),
          isAppend,
        }),
        hasMore: Boolean(dialogs.length),
        loadingChats: false,
        searchCount: count,
      };
    }
    case GET_CHAT_FOLDERS: {
      const payload = action.payload as Folder[] | undefined;
      return { ...state, folders: payload || [], loadingFolders: true };
    }
    case GET_CHAT_FOLDERS_FAILED: {
      return { ...state, loadingFolders: false };
    }
    case GET_CHAT_FOLDERS_SUCCESS: {
      const payload = action.payload as Folder[] | undefined;
      return { ...state, folders: payload || [], loadingFolders: false };
    }
    case GET_CHAT_INFO: {
      return { ...state, loadingChatInfo: true };
    }
    case GET_CHAT_INFO_FAILED: {
      return withError(state, action, { loadingChatInfo: false });
    }
    case GET_CHAT_INFO_SUCCESS: {
      const payload = action.payload as GetChatInfoSuccessPayload;
      if (payload.id !== state.selectedChatId) {
        return { ...state, loadingChatInfo: false };
      }
      if (!payload.loadMore && payload.data.length === 0 && state.chatInfo.length > 0) {
        return { ...state, loadingChatInfo: false };
      }
      const newMessageStatus = payload.loadMore && payload.data.length;
      const chatInfo = updateChatMessages({
        loadMore: payload.loadMore,
        newMessages: payload.data,
        previousMessages: state.chatInfo,
      });
      return { ...state, chatInfo: chatInfo, loadMessageStatus: Boolean(newMessageStatus), loadingChatInfo: false };
    }
    case GET_DIALOG_INFO_FAILED: {
      return withError(state, action);
    }
    case GET_DIALOG_INFO_SUCCESS: {
      return applyDialogInfoSuccess(state, action.payload as SelectedDialogInfo);
    }
    case GET_DIALOG_INFO_BY_PEER: {
      return { ...state, loadingByPeer: true };
    }
    case GET_DIALOG_INFO_BY_PEER_SUCCESS: {
      return applyOpenedDialogFromByPeer(state, action.payload as SelectedDialogInfo);
    }
    case GET_DIALOG_INFO_BY_PEER_FAILED: {
      return withError(state, action, { loadingByPeer: false });
    }
    case GET_FOLDER_DIALOGS_SUCCESS: {
      const payload = action.payload as ChatDescription[];
      return { ...state, editFolderData: { ...state.editFolderData, folderDialogs: payload } };
    }
    case GET_POLL: {
      return { ...state, isPollDetailsLoading: true, pollDetailsError: null, pollInfo: null };
    }
    case GET_POLL_ANSWER_USERS: {
      const payload = action.payload as {
        optionId: string;
        page?: number;
        pollId: string;
      };
      const { optionId, page = 1, pollId } = payload;
      const prev = state.pollAnswerUsersState;
      const isNewOption = prev.optionId !== optionId || prev.pollId !== pollId;
      const resetItems = page === 1 || isNewOption;

      return {
        ...state,
        pollAnswerUsersState: {
          ...prev,
          error: null,
          hasMore: resetItems ? false : prev.hasMore,
          items: resetItems ? [] : prev.items,
          loading: true,
          optionId,
          page,
          pollId,
        },
      };
    }
    case GET_POLL_ANSWER_USERS_FAILED: {
      const payload = action.payload as string | undefined;
      return {
        ...state,
        pollAnswerUsersState: {
          ...state.pollAnswerUsersState,
          error: payload || '',
          loading: false,
        },
      };
    }
    case GET_POLL_ANSWER_USERS_SUCCESS: {
      const payload = action.payload as GetPollAnswerUsersSuccessPayload;
      const items = payload.data ?? [];
      const { limit = POLL_ANSWER_USERS_PAGE_SIZE, optionId, page = 1, pollId } = payload;
      const prev = state.pollAnswerUsersState;
      const shouldAppend = page > 1 && prev.optionId === optionId && prev.pollId === pollId;
      const optionKey = `${pollId}:${optionId}`;
      const noMoreByOptionKey = { ...prev.noMoreByOptionKey };

      if (page === 1 && items.length <= POLL_PREVIEW_VOTERS_COUNT) {
        noMoreByOptionKey[optionKey] = true;
      }

      return {
        ...state,
        pollAnswerUsersState: {
          ...prev,
          error: null,
          hasMore: items.length >= limit,
          items: shouldAppend ? [...prev.items, ...items] : items,
          loading: false,
          noMoreByOptionKey,
          optionId,
          page,
          pollId,
        },
      };
    }
    case GET_POLL_FAILED: {
      const payload = action.payload as string | undefined;
      return {
        ...state,
        isPollDetailsLoading: false,
        pollDetailsError: payload || '',
        pollInfo: null,
      };
    }
    case GET_POLL_SUCCESS: {
      const payload = action.payload as ChatType['pollInfo'];
      return {
        ...state,
        isPollDetailsLoading: false,
        pollDetailsError: null,
        pollInfo: payload || null,
      };
    }
    case GET_UPDATED_CHAT_INFO_FAILED: {
      return withError(state, action, { sendMessagesIsDisabled: true });
    }
    case GET_UPDATED_CHAT_INFO_SUCCESS: {
      const payload = action.payload as GetUpdatedChatInfoSuccessPayload;
      const { fullMessage, isUnread, ...dialogInfo } = payload;
      const info: SelectedDialogInfo = dialogInfo;
      const isOpenDialog = payload.id === state.selectedChatId;

      const chatIdx = state.chats.findIndex((chat) => chat.id === payload.id);
      if (chatIdx !== -1) {
        const updatedChat = applySelectedDialogInfoToListItem(state.chats[chatIdx], info);
        const updatedChats = state.chats.map((chat, idx) => (idx === chatIdx ? updatedChat : chat));

        return {
          ...state,
          chats: updatedChats,
          ...(isOpenDialog && { selectedDialogInfo: info }),
          sendMessagesIsDisabled: false,
        };
      }

      if (payload.isDeleted) {
        return { ...state };
      }

      let newChat = createChatListItemFromSelectedDialogInfo(info);
      if (fullMessage?.id != null) {
        newChat = {
          ...newChat,
          messageId: fullMessage.id,
          preview: getChatPreviewFromWsMessage(fullMessage, newChat, payload.users),
          unreadMessageCount: Math.max(newChat.unreadMessageCount, isUnread ? 1 : 0),
        };
      }

      let newNotificationInfo = state.newNotificationInfo;
      if (isUnread && fullMessage?.id) {
        const author = getUser({ dialog: newChat, userId: fullMessage.owner, users: payload.users });
        newNotificationInfo =
          getNotificationInfo({ dialogId: payload.id, messageId: fullMessage.id, user: author }) ||
          state.newNotificationInfo;
      }

      return {
        ...state,
        chats: sortChatsByPinAndLastMessage([newChat, ...state.chats]),
        newNotificationInfo,
        ...(isOpenDialog && { selectedDialogInfo: info }),
        sendMessagesIsDisabled: false,
      };
    }
    case GET_USERS_LIST: {
      return { ...state, loadingUsersList: true };
    }
    case GET_USERS_LIST_FAILED: {
      return withError(state, action, { loadingUsersList: false, searchCount: 0, usersList: [] });
    }
    case GET_USERS_LIST_SUCCESS: {
      const payload = action.payload as GetUsersListSuccessPayload;
      let searchResult;
      if (payload.isGroup) {
        searchResult = payload.data.users.filter(
          (user) => !(payload.groupMembersIds ?? []).includes(user.id) && payload.userId !== user.id
        );
      } else {
        searchResult = payload.data.users;
      }
      return { ...state, loadingUsersList: false, searchCount: searchResult.length, usersList: searchResult };
    }
    case GET_USERS_STATUS_FAILED: {
      return withError(state, action);
    }
    case GET_USERS_STATUS_SUCCESS: {
      const payload = action.payload as UsersStatusSuccessItem[] | undefined;
      let updatedChats;
      if (payload && payload.length > 0) {
        updatedChats = state.chats.map(function (chat) {
          let updatedChat;
          if (chat.interlocutor) {
            const userId = chat.interlocutor && chat.interlocutor.userId;
            const userStatus = payload.find((user) => user.userId === userId);
            const interlocutorOnlineStatus = userStatus ? userStatus.status : { isOnline: false, lastSeen: null };
            updatedChat = {
              ...chat,
              status: interlocutorOnlineStatus,
            };
          } else {
            updatedChat = { ...chat, status: { isOnline: false, lastSeen: null } };
          }
          return updatedChat;
        });
      } else {
        updatedChats = state.chats;
      }
      return { ...state, chats: updatedChats };
    }
    case INCREASE_MESSAGE_COUNT: {
      const payload = action.payload as ChatDescription[];
      return { ...state, chats: payload };
    }
    case INVITE_USER_FAILED: {
      return withError(state, action);
    }
    case LEAVE_GROUP_FAILED: {
      return withError(state, action);
    }
    case LEAVE_GROUP_SUCCESS: {
      const payload = action.payload as DeleteDialogSuccessPayload;
      const { chats } = state;
      const updatedChats = deleteDialog({ chats, dialog: payload.id });
      const newMobileState = getMobileState({ state, updatedChats });
      const newDesktopState = getDesktopState({ state, updatedChats });
      return payload.isMobile ? newMobileState : { ...newDesktopState, isChatOpen: true };
    }
    case MAKE_USER_ADMIN_SUCCESS: {
      const newAdminId = action.payload as string;
      const newGroupUserList = (state.groupUserList as { userId?: string; role?: ChatUserRolesEnum }[]).map((user) =>
        user.userId === newAdminId ? { ...user, role: ChatUserRolesEnum.admin } : user
      );
      const newSelectedDialogInfo = state.selectedDialogInfo?.users
        ? {
            ...state.selectedDialogInfo,
            users: state.selectedDialogInfo.users.map((user) =>
              user.userId === newAdminId ? { ...user, isAdmin: true, role: ChatUserRolesEnum.admin } : user
            ),
          }
        : state.selectedDialogInfo;
      return {
        ...state,
        groupUserList: newGroupUserList as ChatType['groupUserList'],
        selectedDialogInfo: newSelectedDialogInfo,
      };
    }
    case OPEN_EXISTING_DIALOG: {
      if (typeof action.payload !== 'number') {
        return state;
      }
      return applyOpenExistingDialog(state, action.payload);
    }
    case OPEN_PENDING_CHAT: {
      const { interlocutor } = action.payload as OpenPendingChatPayload;
      return {
        ...state,
        chatContent: ChatContentEnum.chat,
        chatInfo: [],
        isChatOpen: true,
        loadingByPeer: false,
        selectedChatId: null,
        selectedDialogInfo: buildPendingSelectedDialogInfo(interlocutor),
      };
    }
    case PIN_CHAT_FAILED: {
      return withError(state, action);
    }
    case PIN_CHAT_SUCCESS: {
      const payload = action.payload as number;
      const updatedChats = sortChatsByPinAndLastMessage(
        state.chats.map((chat) => (chat.id === payload ? { ...chat, isPinned: true } : chat))
      );
      return { ...state, chats: updatedChats };
    }
    case READ_MESSAGES_FAILED: {
      return withError(state, action);
    }
    case READ_MESSAGES_SUCCESS: {
      const payload = action.payload as ReadMessagesSuccessPayload;
      const { dialogId, messages } = payload;
      const { chats } = state;
      const updatedChats = updateUnreadMessagesCounter({ chats, dialogId, messagesMarkedAsRead: messages });
      return { ...state, chats: updatedChats, loadingChatInfo: false };
    }
    case RECEIVE_WEBSOCKET_MESSAGE: {
      const payload = action.payload as ReceiveWebsocketMessagePayload;
      return applyReceiveWebsocketMessage(state, payload);
    }
    case REMOVE_ADMIN_SUCCESS: {
      const newAdminId = action.payload as string;
      const newGroupUserList = (state.groupUserList as { userId?: string; role?: ChatUserRolesEnum }[]).map((user) =>
        user.userId === newAdminId ? { ...user, role: ChatUserRolesEnum.user } : user
      );
      const newSelectedDialogInfo = state.selectedDialogInfo?.users
        ? {
            ...state.selectedDialogInfo,
            users: state.selectedDialogInfo.users.map((user) =>
              user.userId === newAdminId ? { ...user, isAdmin: false, role: ChatUserRolesEnum.user } : user
            ),
          }
        : state.selectedDialogInfo;
      return {
        ...state,
        groupUserList: newGroupUserList as ChatType['groupUserList'],
        selectedDialogInfo: newSelectedDialogInfo,
      };
    }
    case REMOVE_UPLOAD_GROUP_AVATAR: {
      return { ...state, groupAvatar: null };
    }
    case REORDER_FOLDERS: {
      const payload = action.payload as Folder[] | undefined;
      return { ...state, folders: payload || [], loadingFolders: true };
    }
    case REORDER_FOLDERS_FAILED: {
      return { ...state, loadingFolders: false };
    }
    case REORDER_FOLDERS_SUCCESS: {
      return { ...state, loadingFolders: false };
    }
    case RESET_SEARCH_RESULT: {
      const payload = action.payload as number;
      return { ...state, searchCount: payload, usersList: [] };
    }
    case SEARCH_DIALOGS: {
      return { ...state, loadingSearchDialogs: true };
    }
    case SEARCH_DIALOGS_FAILED: {
      return withError(state, action, { loadingSearchDialogs: false });
    }
    case SEARCH_DIALOGS_SUCCESS: {
      const payload = action.payload as ChatDescription[];
      return { ...state, errorText: '', foundDialogs: payload, loadingSearchDialogs: false };
    }
    case SEARCH_GLOBAL_CHAT: {
      return { ...state, loading: true };
    }
    case SEARCH_GLOBAL_CHAT_FAILED: {
      return withError(state, action, { loading: false });
    }
    case SEARCH_GLOBAL_CHAT_SUCCESS: {
      const payload = action.payload as ChatType['foundChats'];
      return { ...state, errorText: '', foundChats: payload, loading: false };
    }
    case SEARCH_IN_DIALOG: {
      const payload = action.payload as SearchDialogUrlParams;
      if (payload.isAppend) {
        return { ...state, loadingSearchInDialog: true };
      }
      return {
        ...state,
        errorText: '',
        hasMoreSearchInDialog: false,
        loadingSearchInDialog: true,
        searchInDialogQuery: toSearchInDialogQuery(payload),
      };
    }
    case SEARCH_IN_DIALOG_FAILED: {
      return withError(state, action, { hasMoreSearchInDialog: false, loadingSearchInDialog: false });
    }
    case SEARCH_IN_DIALOG_SUCCESS: {
      if (!state.searchInDialogQuery) {
        return { ...state, loadingSearchInDialog: false };
      }
      const payload = action.payload as SearchInDialogSuccessPayload;
      const { payload: data, isAppend } = payload;
      const searchMessageResult = isAppend ? [...state.searchMessageResult, ...data] : data;
      const pageSize = state.searchInDialogQuery.limit ?? chats.searchInDialogPageSize;

      return {
        ...state,
        errorText: '',
        hasMoreSearchInDialog: data.length === pageSize,
        loadingSearchInDialog: false,
        searchMessageResult,
      };
    }
    case SELECT_CHAT: {
      const id = typeof action.payload === 'number' ? action.payload : null;
      return applySelectChat(state, id);
    }
    case SELECT_CHAT_FOLDER: {
      const payload = action.payload as Folder['id'] | null;
      return { ...state, folder: payload };
    }
    case SET_ANSWER_MESSAGE: {
      const payload = action.payload as ChatMessage | null;
      return {
        ...state,
        answerMessage: payload as ChatMessage | undefined,
      };
    }
    case SET_CHAT_CONTENT: {
      const payload = action.payload as ChatContentEnum;
      return { ...state, chatContent: payload };
    }
    case SET_EDITABLE_MESSAGE: {
      const payload = action.payload as SetEditableMessagePayload | null | undefined;
      const { mode = false, payload: editableMessage = null } = payload || {};
      return {
        ...state,
        editableMessage,
        isEditMode: mode,
      };
    }
    case SET_FOLDER_DATA: {
      const payload = action.payload as ChatType['editFolderData'];
      return { ...state, editFolderData: payload };
    }
    case SET_FOLDERS: {
      const payload = action.payload as Folder[];
      return { ...state, folders: payload };
    }
    case SET_GROUP_USER_LIST: {
      const payload = action.payload as ChatType['groupUserList'];
      return { ...state, groupUserList: payload };
    }
    case SET_SELECTED_MESSAGES: {
      const payload = action.payload as number[];
      return { ...state, selectedMessages: payload };
    }
    case SET_SELECTION_MODE: {
      const payload = action.payload as boolean;
      return {
        ...state,
        selectedMessages: payload ? state.selectedMessages : [],
        selectionMode: payload,
      };
    }
    case STOP_POLL: {
      return { ...state, isPollLoading: true };
    }
    case STOP_POLL_FAILED: {
      return {
        ...state,
        isPollLoading: false,
        pollActionError: true,
      };
    }
    case STOP_POLL_SUCCESS: {
      const payload = action.payload as StopPollSuccessPayload | undefined;
      if (!payload?.poll) {
        return { ...state, isPollLoading: false };
      }
      const poll = payload.poll;
      return {
        ...state,
        chatInfo: updatePollInChatInfo(state.chatInfo, poll.i, poll),
        isPollLoading: false,
        pollActionError: false,
      };
    }
    case SUBMIT_POLL_ANSWER: {
      return { ...state, isPollLoading: true };
    }
    case SUBMIT_POLL_ANSWER_FAILED: {
      return {
        ...state,
        isPollLoading: false,
        pollActionError: true,
      };
    }
    case SUBMIT_POLL_ANSWER_SUCCESS: {
      const payload = action.payload as PollVoteSuccessPayload | undefined;
      if (!payload?.poll) {
        return { ...state, isPollLoading: false };
      }
      const poll = payload.poll;
      return {
        ...state,
        chatInfo: updatePollInChatInfo(state.chatInfo, poll.i, poll),
        isPollLoading: false,
        pollActionError: false,
      };
    }
    case TOGGLE_CHAT: {
      return { ...state, isChatOpen: !state.isChatOpen };
    }
    case UNBLOCK_DIALOG: {
      return { ...state, loadingChatInfo: true };
    }
    case UNBLOCK_DIALOG_FAILED: {
      return withError(state, action, { loadingChatInfo: false });
    }
    case UNBLOCK_DIALOG_SUCCESS: {
      const payload = action.payload as number;
      const newChats = [...state.chats].filter((chat) => chat.id !== payload);
      return { ...state, chats: newChats, loadingChatInfo: false };
    }
    case UNPIN_CHAT_FAILED: {
      return withError(state, action);
    }
    case UNPIN_CHAT_SUCCESS: {
      const payload = action.payload as number;
      const updatedChats = sortChatsByPinAndLastMessage(
        state.chats.map((chat) => (chat.id === payload ? { ...chat, isPinned: false } : chat))
      );
      return { ...state, chats: updatedChats };
    }
    case UPDATE_GROUP: {
      return { ...state, error: false, errorText: '', loading: true };
    }
    case UPDATE_GROUP_FAILED: {
      const payload = action.payload as PayloadErrorType;
      return { ...state, error: true, errorText: payload.message, loading: false };
    }
    case UPDATE_GROUP_SUCCESS: {
      const payload = action.payload as UpdateGroupSuccessPayload;
      if (!state.selectedDialogInfo) {
        return { ...state, error: false, errorText: '', loading: false };
      }
      const imageFromPayload =
        payload.image ?? (typeof payload.dialogImage === 'object' ? payload.dialogImage : null);
      const isClearImage = payload.dialogImage === '' || payload.image === null;
      const isNewImage = isClearImage || Boolean(imageFromPayload);

      const newSelectedDialogInfo = {
        ...state.selectedDialogInfo,
        ...(payload.name && { name: payload.name }),
        ...(isNewImage && { image: isClearImage ? null : imageFromPayload }),
        users: payload.users,
      };

      const updatedChats = state.chats.map((chat) => {
        if (chat.id !== payload.id) {
          return chat;
        }
        const { users: _users, ...listChat } = chat as ChatDescription & { users?: unknown };
        const nextName = payload.name ?? newSelectedDialogInfo.name ?? listChat.name;
        const nextImage = isNewImage
          ? isClearImage
            ? null
            : imageFromPayload
          : newSelectedDialogInfo.image ?? listChat.image;
        return {
          ...listChat,
          image: nextImage,
          name: nextName ?? null,
        };
      });
      const newGroupUserList = payload.users.map((user) => ({
        imageUrl: user?.image?.path,
        initials: getInitialsFromFullname(user.fullName),
        isAdmin: user.isAdmin,
        role: user.role,
        userId: user.userId,
        userName: user.fullName,
      }));
      return {
        ...state,
        chats: updatedChats,
        error: false,
        errorText: '',
        groupUserList: newGroupUserList,
        loading: false,
        selectedDialogInfo: newSelectedDialogInfo,
      };
    }
    case UPDATE_MESSAGE_FAILED: {
      return withError(state, action);
    }
    case UPDATE_MESSAGE_SUCCESS: {
      const payload = action.payload as UpdateMessagePayload;
      const updatedChat = state.chatInfo.map((message) => {
        if (message.id === payload.messageId) {
          return {
            ...message,
            files: payload.files ?? message.files,
            text: payload.updatedText,
          };
        }
        return message;
      });
      return { ...state, chatInfo: updatedChat };
    }
    case UPLOAD_ATTACHED_FILE_SUCCESS: {
      const payload = action.payload as UploadFileSuccessPayload;
      const { data } = payload;
      const update: Partial<ChatType> = {};
      if (data) update.lastUploadFiles = state.lastUploadFiles.concat(data as FileDescriptor[]);
      return { ...state, ...update };
    }
    case UPLOAD_FILE_FAILED: {
      return withError(state, action);
    }
    case UPLOAD_GROUP_AVATAR_SUCCESS: {
      const payload = action.payload as UploadFileSuccessPayload;
      const { data } = payload;
      const update = { groupAvatar: (data as FileDescriptor[])[0] };
      return { ...state, ...update };
    }
    default: {
      return state;
    }
  }
};
